import React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'

import Box from '../components/Box'
import PropertyLabel from '../components/PropertyLabel'
import ErrorMessage from '../components/ErrorMessage'
import LoadingProgress from '../components/LoadingProgress'

import { fetchCustomerGroup } from '../actions/customers'
import AssignedZoneList from '../components/AssignedZoneList'

class CustomerGroupDetailsView extends React.Component {
  componentDidMount() {
    this.props.fetchCustomerGroup(this.props.match.params.id)
  }

  render() {
    const { role, type, customer, error, loading } = this.props

    if (error) {
      return (
        <ErrorMessage message={error.message} />
      )
    }

    if (!customer || loading) {
      return <LoadingProgress />;
    }

    return (
      <div>
        <div className="row mb-2">
          <div className="col-xs-12 col-sm-8 col-md-8">
            <h1>
              <span className="text-vw-light">USUARIO GRUPO</span>
              <span className="text-vw-dark">{customer.Fullname}</span>
            </h1>
          </div>
          {(role === 'ADMIN' && type === 'MASTER') &&
            <div className="col-xs-12 col-sm-4 col-md-4 text-right">
              <Link to={`/customersgroup/${customer._id}/edit`}>
                <button className="btn bg-vw-light text-white mr-1">
                  <i className="fas fa-edit mr-1"></i>Editar
                </button>
              </Link>
            </div>
          }
        </div>
        <div className="row">
          <div className="col-xs-12 col-md-4">
            <Box title="Cliente" icon="user">
              <PropertyLabel name="Nombre completo"
                value={customer.Fullname} />
              <PropertyLabel name="E-Mail"
                value={customer.Email} />
              <PropertyLabel name="Grupo"
                value={customer.Group} />
              <PropertyLabel name="Última edición" ml
                value={customer.Executor} />
            </Box>
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = state => ({
  customer: state.customers.customer,
  loading: state.customers.loading,
  error: state.customers.error,
  role: state.auth.role,
  type: state.auth.type
})

const mapDispatchToProps = dispatch => ({
  fetchCustomerGroup: bindActionCreators(fetchCustomerGroup, dispatch)
})

export default connect(mapStateToProps, mapDispatchToProps)(CustomerGroupDetailsView)
